import { useState } from "react";
import { CheckIcon, XIcon, WarningIcon } from "@phosphor-icons/react";
import { Checkbox } from "barte-design-system";
import {
  BANKING_PERMISSIONS_MAP,
  ACQUIRING_PERMISSIONS_MAP,
  type PermissionStatus,
} from "../../constants";
import type { UserPermissionsInfoProps } from "./user-permissions-info.type";
import styles from "./user-permissions-info.module.css";

const PERMISSION_ICON_MAP: Record<PermissionStatus, { className: string; icon: JSX.Element }> = {
  allowed: {
    className: "icon-allowed",
    icon: <CheckIcon className={styles["icon-svg"]} weight="bold" />,
  },
  denied: {
    className: "icon-denied",
    icon: <XIcon className={styles["icon-svg"]} weight="bold" />,
  },
  restricted: {
    className: "icon-restricted",
    icon: <WarningIcon className={styles["icon-svg-warning"]} weight="fill" />,
  },
};

const PermissionIcon = ({ status }: { status: PermissionStatus }) => {
  const config = PERMISSION_ICON_MAP[status];
  return (
    <span className={styles[config.className]}>
      {config.icon}
    </span>
  );
};

export const UserPermissionsInfo = ({
  bankingSelectedProfile,
  acquiringSelectedProfile,
}: UserPermissionsInfoProps) => {
  const userInfo = JSON.parse(localStorage.getItem("barte-user-info") || "{}");
  const hasBankingAccess = userInfo?.bankingStatus === "ACTIVE";

  const [showPerm, setShowPerm] = useState<"BANKING" | "ACQUIRING">(
    hasBankingAccess ? "BANKING" : "ACQUIRING",
  );

  const bankingProfile = BANKING_PERMISSIONS_MAP[bankingSelectedProfile ?? ""];
  const acquiringProfile = ACQUIRING_PERMISSIONS_MAP[acquiringSelectedProfile ?? ""];

  const activeProfile = showPerm === "BANKING" ? bankingProfile : acquiringProfile;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Permissões do perfil selecionado:</h2>
      </div>
      <div className={styles.content}>
        <div className={styles["toggle-row"]}>
          {hasBankingAccess && (
            <Checkbox
              defaultChecked={showPerm === "BANKING"}
              onChange={() => setShowPerm("BANKING")}
              label="Banking"
            />
          )}
          <Checkbox
            defaultChecked={showPerm === "ACQUIRING"}
            onChange={() => setShowPerm("ACQUIRING")}
            label="Adquirência"
          />
        </div>

        {!activeProfile ? (
          <p className={styles["empty-text"]}>Selecione um perfil para ver as permissões</p>
        ) : (
          <>
            <ul className={styles["permission-list"]}>
              {activeProfile.permissions.length > 0 && activeProfile.permissions.map((item, idx) => (
                <li key={idx} className={styles["permission-item"]}>
                  <PermissionIcon status={item.status} />
                  <span>{item.label}</span>
                </li>
              ))}
            </ul>
            {activeProfile.note && (
              <p className={styles.note}>{activeProfile.note}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};
